import { Draft } from "immer";
import LoyaltyState from "./LoyaltyRewardsState";
import { LoyaltyCollectionModel } from "./LoyaltyRewardsModel";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

const initialState: LoyaltyState = {
    isLoading: true,
    loyalty: {},
    isMyAccountPageReloaded: false,
    isAdIProRewardsLoaded:false,

};

const reducer = {
    "AccountPage/GetLoyaltyReward": (draft: Draft<LoyaltyState>) => {
        draft.isLoading = true;
    },
    "Accountpage/DispatchCompleteLoadLoyalty": (
        draft: Draft<LoyaltyState>,
        action: { loyalty: LoyaltyCollectionModel },
    ) => {
        draft.isLoading = false;
        draft.loyalty = action.loyalty;
    },
    "AccountPage/RouteUpdate": (draft: Draft<LoyaltyState>) => {
        draft.isMyAccountPageReloaded = true;
    },
    "AccountPage/RouteDeactivate": (draft: Draft<LoyaltyState>) => {
        draft.isMyAccountPageReloaded = false;
    },
    "AccountPage/ProRewardsUpdate": (draft: Draft<LoyaltyState>) => {
        draft.isAdIProRewardsLoaded = true;
    },
    "AccountPage/ProRewardReset": (draft: Draft<LoyaltyState>) => {
        draft.isAdIProRewardsLoaded = false;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);